var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isShowOpenState)?_c('div',{staticClass:"venue-open-state",class:_vm.elementSize && `venue-open-state--${_vm.elementSize}`},[_c('div',{staticClass:"icon-holder"},[_c('img',{staticClass:"venue-open-state__icon",attrs:{"src":_vm.icons.foodIcon,"alt":"Food image"}})]),_vm._v(" "+_vm._s(_vm.venueOpenStateText)+" ")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }